import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart, Check, Bell } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// Reusable follow/subscribe toggle. kind: venue|operator|genre|interest|topic
export default function FollowButton({ kind, subjectKey, label, className = "", icon = "bell" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [following, setFollowing] = useState(false);
  const [sid, setSid] = useState(null);
  const isCustomer = user && user.role === "customer";

  useEffect(() => {
    if (!isCustomer) return;
    api.get("/me/subscriptions").then((r) => {
      const m = r.data.find((s) => s.kind === kind && s.key === subjectKey);
      if (m) { setFollowing(true); setSid(m.id); }
    }).catch(() => {});
  }, [isCustomer, kind, subjectKey]);

  const toggle = async () => {
    if (!user) { toast("Sign in to follow", { description: "Create a free account to follow and get alerts." }); nav("/account/login"); return; }
    if (!isCustomer) { toast.error("Switch to a visitor account to follow places"); return; }
    try {
      if (following && sid) {
        await api.delete(`/me/subscriptions/${sid}`);
        setFollowing(false); setSid(null);
        toast("Unfollowed");
      } else {
        const { data } = await api.post("/me/subscriptions", { kind, key: subjectKey, label, frequency: "instant" });
        setFollowing(true); setSid(data.id);
        toast.success(`Following ${label} — you'll get alerts`);
      }
    } catch { toast.error("Something went wrong"); }
  };

  const Ic = icon === "heart" ? Heart : Bell;
  return (
    <button onClick={toggle} data-testid={`follow-${kind}-${subjectKey}`}
      className={`inline-flex items-center justify-center gap-2 text-sm font-semibold transition-colors ${following ? "bg-[#00FF66] text-black" : "bg-[#FF0055] hover:bg-[#ff2d74] text-white"} ${className}`}>
      {following ? <><Check size={16} /> Following</> : <><Ic size={16} /> Follow</>}
    </button>
  );
}
